import React from 'react';
import styled from 'styled-components';
import { translate } from '../../../common/translation/translate';
import { mediumMediaQuery, smallMediaQuery } from '../../../common/utilities/sizeHelpers';
import { ErrorBoundaryIcon } from '../../common/errorBoundary/errorBoundaryIcon';

export const HurricaneWidgetErrorUI = () :JSX.Element => {
    return (
        <Container>
            <HurricaneWidgetIconWrapper>
                <ErrorBoundaryIcon fillColor='#8E8E93'/>
            </HurricaneWidgetIconWrapper>
            <HurricaneWidgetTitle>{translate('failedToLoad')}</HurricaneWidgetTitle>
            <NoDataDescriptionWrapper>
                <HurricaneWidgetErrorDescriptionText>{translate('dataLoadFirstErrorMessage')}</HurricaneWidgetErrorDescriptionText>
                <HurricaneWidgetErrorDescriptionText>{translate('dataLoadSecondErrorMessage')}</HurricaneWidgetErrorDescriptionText>
            </NoDataDescriptionWrapper>
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    padding: 12px 10px;
    background: #f9f9f9;
    justify-content: center;
    align-items:center;
    width: 100%;
    gap: 12px;
    height: 100%;
`;

const NoDataDescriptionWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;
const HurricaneWidgetIconWrapper = styled.span`
    display: flex;
    flex-direction: column;
    background: rgba(142, 142, 147, 0.1);
    justify-content: center;
    align-items: center;
    border-radius: 24px;
    width: 48px;
    height: 48px;
    padding: 8px;
    @media (${mediumMediaQuery}) or (${smallMediaQuery}) {
        border-radius: 12px;
        padding: 4px;
        width: 24px;
        height: 24px;
}
`;
const HurricaneWidgetTitle = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    font-family: Source Sans Pro;
    font-style: normal;
    font-size: 16px;
    line-height: 20px;
    color: #333333;
    font-weight: 600;
    @media (${mediumMediaQuery}) or (${smallMediaQuery}) {
        font-size: 10px;
        line-height: 14px;
`;

const HurricaneWidgetErrorDescriptionText = styled.span`
    font-family: Source Sans Pro;
    font-style: normal;
    font-size: 16px;
    line-height: 20px;
    color: #333333;
    font-weight: normal;
    @media (${mediumMediaQuery}) or (${smallMediaQuery}) {
        line-height: 10px;
        font-size: 8px;
    }
`;